import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  CanAccess,
  AuthorizationList,
} from "../../../components/template/authorization/Authorization";
import AppRoutePath from "../../../router/AppRoutePath";
import { Link } from "react-router-dom";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleDelete) => {
  return [
    {
      dataIndex: "name",
      key: "name",
      title: "Cabang/Outlet",
    },
    {
      dataIndex: "cataegory",
      key: "category",
      title: "Kategori Product",
      render: (_, record) => (
        <div>
          {record.outlet_appraisers.map((item) => {
            return <div className="my-3">{item.product_category_name}</div>;
          })}
        </div>
      ),
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Nama Juru Taksir",
      render: (_, record) => (
        <div>
          {record.outlet_appraisers.map((item) => {
            return <div className="my-3">{item.appraiser_name}</div>;
          })}
        </div>
      ),
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.create_outlet_appraiser}
            yes={
              <Link
                to={{
                  pathname: AppRoutePath.APPRAISER_EDIT_BY_OUTLET.replace(
                    ":id",
                    record.id
                  ),
                  dataEdit: record,
                }}
              >
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </Link>
            }
          />
          <CanAccess
            role={AuthorizationList.delete_outlet_appraiser}
            yes={
              <div className="mx-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
